var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMensaje(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_192",
    "data-name": "Grupo 192",
    transform: "translate(-1094 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    transform: "translate(1094 18)",
    fill: "none",
    stroke: "#122866",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(1103.642 30.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_141",
    "data-name": "Grupo 141",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_89",
    "data-name": "Trazado 89",
    d: "M0,8.589A2.589,2.589,0,0,1,2.589,6H18.126a2.589,2.589,0,0,1,2.589,2.589V18.947a2.589,2.589,0,0,1-2.589,2.589H2.589A2.589,2.589,0,0,1,0,18.947ZM2.589,7.295A1.3,1.3,0,0,0,1.295,8.589V8.87l9.063,5.438L19.421,8.87V8.589a1.3,1.3,0,0,0-1.295-1.295ZM19.421,10.38l-6.1,3.658,6.1,3.751Zm-.044,8.9-7.3-4.494-1.717,1.029L8.641,14.789l-7.3,4.493a1.3,1.3,0,0,0,1.251.961H18.126a1.3,1.3,0,0,0,1.251-.96ZM1.295,17.788l6.1-3.751-6.1-3.658Z",
    transform: "translate(0 -6)",
    fill: "#122866"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensaje);
export default __webpack_public_path__ + "static/media/mensaje.406de72569faf79070f5952ca16cadf4.svg";
export { ForwardRef as ReactComponent };